import { ExitModalVariants } from 'modules/dataWarehouse/constants';
import { BUTTON_VARIANTS, Button } from 'ui/button';
import { MODAL_SIZES, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';

const EXIT_MODAL_TEXT = {
  [ExitModalVariants.CREATE_SOURCE]: {
    title: 'Exit source setup?',
    body: "You will lose any progress you've made while setting up your source connection.",
  },
  [ExitModalVariants.CREATE_SYNC]: {
    title: 'Exit sync setup?',
    body: "You will lose any progress you've made while setting up your sync.",
  },
  default: {
    title: 'Exit setup?',
    body: "You will lose any progress you've made.",
  },
};

type ExitModalProps = {
  handleCancel: () => void;
  handleConfirm: () => void;
  variant: ExitModalVariants;
};

export const ExitModal = ({ handleCancel, handleConfirm, variant }: ExitModalProps) => {
  const { title, body } = EXIT_MODAL_TEXT[variant] || EXIT_MODAL_TEXT.default;

  return (
    <Modal id="exit-modal" isModalOpen onClose={handleCancel} size={MODAL_SIZES.SMALL}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>{body}</ModalBody>
      <ModalFooter>
        <Button onClick={handleConfirm} variant={BUTTON_VARIANTS.DESTRUCTIVE}>
          Exit to dashboard
        </Button>
      </ModalFooter>
    </Modal>
  );
};
